import { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";
import useTranslation from "../../../../hooks/useTranslation";
import { EtablissementValidationType } from "../../../../schemas-and-types/etablissement/etablissemen.schema";
import InputSection from "../../../global/InputSection/InputSection";
import PhoneSection from "../../../global/PhoneSection/PhoneSection";
import styles from "./InformationsRefVMV.module.scss";

type Props = {
  register: UseFormRegister<EtablissementValidationType>;
  formErrors: FieldErrors<EtablissementValidationType>;
  setRegisterValue: UseFormSetValue<any>; // TODO : Remove 'any' type
};

function InformationsRefVMV(props: Props) {
  const { register, formErrors, setRegisterValue } = props;
  const { t } = useTranslation();

  return (
    <article className={styles.inscriptionEtablissement__main__infoRef}>
      <h2>{t('establishment.info.referent.title')}</h2>
      <p>
        {/* {t('establishment.info.referent.description')} */}
      </p>
      <article
        className={styles.inscriptionEtablissement__main__infoRef__inputs}
      >
        <section>
          <InputSection
            label={t('establishment.info.referent.lastName')}
            inputId="inscriptionEtab_infoRef_nomRef"
            inputType="text"
            placeholder={t('establishment.info.referent.lastName')}
            name="nom_referent"
            required
            register={register}
            formErrors={formErrors}
          />

          <InputSection
            label={t('establishment.info.referent.firstName')}
            inputId="inscriptionEtab_infoRef_prenomRef"
            inputType="text"
            placeholder={t('establishment.info.referent.firstName')}
            name="prenom_referent"
            required
            register={register}
            formErrors={formErrors}
          />
        </section>

        <section>
          <InputSection
            label={t('establishment.info.referent.email')}
            inputId="inscriptionEtab_infoRef_emailRef"
            inputType="text"
            placeholder="vorname.name@korian.de"
            name="email_referent"
            required
            register={register}
            formErrors={formErrors}
          />

          <PhoneSection
            label={t('establishment.info.referent.phone')}
            inputId="inscriptionEtab_infoRef_phoneRef"
            placeholder="0 00 00 00 00"
            name="phone_referent"
            required
            register={register}
            formErrors={formErrors}
            setRegisterValue={setRegisterValue}
          />
        </section>
      </article>
    </article>
  );
}

export default InformationsRefVMV;
